

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function extractWarrantyInformation(inputString) {
  inputStringLowerCase = inputString.toLowerCase();
  let price = null;
  let savedMoney = null;
  let promotionDescription = null;
  if (inputStringLowerCase.includes("2 year") || inputStringLowerCase.includes("4 year")) {
    const priceMatch = inputString.match(/\+\$(\d+)/);
    price = priceMatch ? "$" + priceMatch[1] : null;

    const savedMoneyMatch = inputString.match(/Save\s+\$(\d+)/);
    const savedMoneyText = "Save $";
    savedMoney = savedMoneyMatch ? savedMoneyText + savedMoneyMatch[1] : null;
  }
  return [price, savedMoney];
}

// Function to get three-letter abbreviation of the day of the week
function getDayAbbreviation(dayOfWeek) {
  var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  return days[dayOfWeek];
}

// Function to format time as "HH:mm AM/PM"
function formatTime(hours, minutes) {
  var period = hours >= 12 ? "PM" : "AM";
  var formattedHours = hours % 12 || 12; // Convert to 12-hour format
  var formattedMinutes = String(minutes).padStart(2, "0"); // Ensure minutes are always two digits
  return formattedHours + ":" + formattedMinutes + " " + period;
}

async function getCurrentSelectedStoreLocationData () {
  const currentStoreId = GetSelectedStoreId();
  var store_locations_url = getStoreLocationsJson();
  const storesData = await fetch(store_locations_url);
  const storesDataJson = await storesData.json();
  const currentSelectedStoreLocationData = storesDataJson.filter(storeData => storeData.id === currentStoreId);
  return currentSelectedStoreLocationData;
}

function setLocalStorageWithExpiry(key, value, days) {
  const now = new Date()

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + (days*24*60*60*1000),
  }
  localStorage.setItem(key, JSON.stringify(item))
}

function getLocalStorageWithExpiry(key) {
  const itemStr = localStorage.getItem(key)

  // if the item doesn't exist, return null
  if (!itemStr) {
    return null
  }

  const item = JSON.parse(itemStr)
  const now = new Date()

  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key)
    return null
  }
  return item.value
}

function isEmail(email)
{
  return email.match(/^[\+_a-z0-9-'&=]+(\.[\+_a-z0-9-']+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i);
}

function WriteCookie(cookieName, cookieValue, expirationInDays)
{
    var date = new Date();
  	date.setTime(date.getTime()+(expirationInDays*24*60*60*1000));
  	var expires = "; expires="+date.toGMTString();
   	document.cookie = cookieName + "=" +cookieValue + ";" +expires+"; path=/";
}

function GetClosestStore(lat, long, storedata){

  	var closestStore = null;
  	var distance = 0;
  	var unit = 'K';

   for (var i in storedata) {
     if (distance == 0)
     {
       distance = GetDistance(lat, long, storedata[i].lat, storedata[i].lng, unit);
       closestStore = storedata[i];
     }
     else {
       var tempdistance = GetDistance(lat, long, storedata[i].lat, storedata[i].lng, unit);
       if (tempdistance < distance)
       {
         distance = tempdistance;
         closestStore = storedata[i];
       }
     }
   }

  return closestStore;
}


function GetDistance(lat1, lon1, lat2, lon2, unit) {
    var radlat1 = Math.PI * lat1/180
    var radlat2 = Math.PI * lat2/180
    var theta = lon1-lon2
    var radtheta = Math.PI * theta/180
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
        dist = 1;
    }
    dist = Math.acos(dist)
    dist = dist * 180/Math.PI
    dist = dist * 60 * 1.1515
    if (unit=="K") { dist = dist * 1.609344 }
    if (unit=="N") { dist = dist * 0.8684 }
    return dist;
}

function GetStoreCookieValue(province, storeid, region)
{
 return   '{"province":"' + province  +'", "storeid":'+ storeid +', "region":"' + region  +'"}';
}

// GetDeliveryDate should work as:
// example 1: GetDeliveryDate(1, true): today (Fri) + 1 business days (Sat), return "tomorrow"
// example 2: GetDeliveryDate(2, true): today (Fri) + 2 business days (Sat, Mon), return Mon *** ** 2023
// example 3: GetDeliveryDate(4, true): today (Thu) + 4 business days (Fri, Sat, Mon, Tue), return Tue *** ** 2023
// addBusinesskDays considers Mon-Sat as business days, Sun as non-business day
function GetDeliveryDate(days, isBusinessDays)
{
    var date = new Date();
 	if (isBusinessDays == false)
    {
        var intdays = parseInt(days);
      	date.setDate(date.getDate() + intdays);

    }
  	else
    {
    	date = addBusinesskDays(date, days);
  	}

    date.setHours(0, 0, 0, 0);
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);

    if (date.getTime() === today.getTime()) {
        return "today";
    } else if (date.getTime() === tomorrow.getTime()) {
        return "tomorrow";
    } else {
        return date.toDateString();
    }
}

function addBusinesskDays(startDate, days) {
  if(isNaN(days)) {
      console.log("Value provided for \"days\" was not a number");
      return
  }
  if(!(startDate instanceof Date)) {
      console.log("Value provided for \"startDate\" was not a Date object");
      return
  }

  // This algorithm only works if the non-business days are consecutive
  const numNonBusinessDays = 1;   // only Sunday is not a business day
  const numBusinessDays = 7 - numNonBusinessDays;

  // Get the day of the week as a number (0 = Sunday, 1 = Monday, .... 6 = Saturday)
  var dow = startDate.getDay();
  var daysToAdd = parseInt(days);
  // If the current day is Sunday add one day
  if (dow == 0)
      daysToAdd++;
  // If the start date plus the additional days falls on or after the closest Saturday calculate weekends
  if (dow + daysToAdd > numBusinessDays) {
      //Subtract days in current working week from work days
      var remainingWorkDays = daysToAdd - (numBusinessDays - dow);
      //Add current working week's weekend
      daysToAdd += numNonBusinessDays;
      if (remainingWorkDays > numBusinessDays) {
          //Add numNonBusinessDays for each working week by calculating how many weeks are included
          daysToAdd += numNonBusinessDays * Math.floor(remainingWorkDays / numBusinessDays);
          //Exclude final weekend if remainingWorkDays resolves to an exact number of weeks
          if (remainingWorkDays % numBusinessDays == 0)
              daysToAdd -= numNonBusinessDays;
      }
  }
  startDate.setDate(startDate.getDate() + daysToAdd);
  return startDate;
}

function StringToBoolean(string)
{
  switch(string.toLowerCase().trim()){
        case "true": case "yes": case "1": return true;
        case "false": case "no": case "0": case null: return false;
        default: return Boolean(string);
    }
}


function ClickDelayed(button, delay, loop)
{
      setTimeout(function () {
		button.click();
    }, delay * loop);

}

function RemoveBaseUrl(url) {
  var baseUrlPattern = /^https?:\/\/[a-z0-9-]+(\.[a-z0-9-]+)*?(:[0-9]+)?(\/)+/;
  var result = "";

  var match = baseUrlPattern.exec(url);
  if (match != null) {
      result = match[0];
  }

  if (result.length > 0) {
      url = "/".concat(url.replace(result, ""));
  }

  return url;
}

function GetCurrentURL(removeParamaters, removeBaseURL)
{
  	var url = window.location.href;
  	if (removeBaseURL == true)
    {
      	url = RemoveBaseUrl(window.location.href);

    }

 	if ( removeParamaters == false)
    {
     	return  url;
    }
  	else {
    	return url.split('?')[0];
  }

}

function GetPageBaseURL(){
  const currentURL = GetCurrentURL(true, false);
  var baseUrlPattern = /^https?:\/\/[a-z0-9-]+(\.[a-z0-9-]+)*?(:[0-9]+)?(\/)+/;
  return baseUrlPattern.exec(currentURL)[0];
}

function GetHandle(){
  const currentURL = GetCurrentURL(true, true);
  const currentURLArray =  currentURL.split('/');
  return currentURLArray[currentURLArray.length - 1] ;
}

function GetSelectedStoreId()
{
  var selectedStore = readCookie(storeCookieKey);
  if (selectedStore != null)
  {
    var storeinfo = JSON.parse(selectedStore);
    return storeinfo.storeid;

  }
  else {
   	return  0;
  }

}

async function GetSelectedStoreRegion() {
  var selectedStore = readCookie(storeCookieKey);
  if (selectedStore != null)
  {
    var storeinfo = JSON.parse(selectedStore);
    if (!storeinfo.region){
      const store_region = await fetchRegionFromStoreSelectorJSON();
      await WriteStoreCookie(storeinfo.province, storeinfo.storeid, store_region, defaultStoreCookieDuration);
      return store_region;
    } else {
      return storeinfo.region;
    }
  } else {
     return null;
  }
}

function fetchRegionFromStoreSelectorJSON() {
  var store_locations_url = getStoreLocationsJson();
  return new Promise(function(resolve, reject){
   $.getJSON(store_locations_url, function(storedata) {
     for (i in storedata) {
       if(storeinfo.storeid == storedata[i].id){
         resolve(storedata[i].region);
       }
     }
   });
  });
}

function WriteStoreCookie(province, storeId, region, cookieDuration){
  var storeCookieValue = GetStoreCookieValue(province, storeId, region);
  WriteCookie(storeCookieKey, storeCookieValue, cookieDuration);
}

function handleClearanceFilterOnMobile(clearanceRegionNameMobile){
  /** clearance mobile **/
  /** mobile-- hide all the other regions except the region to which the slected store location belongs to **/
  setTimeout(function(){
  if ($jquery_isp('#mobile_facet_container').length > 0 )
  {
        var mobileMenu = $jquery_isp('#mobile_facet_container');
        $jquery_isp(mobileMenu).find('.mobile_facet_group').each(function(){
          var $this = $(this);
          if ($jquery_isp($this).find('.isp_facet_group_title_text').text() == 'Clearance')
          {
            // press the more button
            if ($jquery_isp($this).find('.toggle_facets').text().trim() == "more +")
            {
              $jquery_isp($this).find('.toggle_facets').trigger('click');

            }
            $jquery_isp($this).find('.isp_single_mobile_facet').each(function(){
              if ($jquery_isp(this).find('.isp_mobile_filter').text().trimEnd()  != clearanceRegionNameMobile)
              {
                if ($jquery_isp(this).find('.isp_mobile_filter').text().trimEnd() != '')
                {
                    $jquery_isp(this).addClass('hidden');
                }
              }
            });
          }
      });
  }
  }, 2000);

  /** mobile-- hide the whole clearance section when there is no checkbox matches with the region to which the slected store location belongs to **/
  if(document.getElementById('facet_group_clearance')){
    var clearance_checkboxes = document.getElementById('facet_group_clearance').querySelectorAll('.isp_single_mobile_facet');
    const checkbox_matched = Array.from(clearance_checkboxes).filter(checkbox => {if(checkbox.querySelector('.isp_mobile_filter')){return checkbox.querySelector('.isp_mobile_filter').textContent.trimEnd() == clearanceRegionNameMobile}});
    if (checkbox_matched.length == 0) {
      $('#facet_group_clearance').addClass('hidden');
    }
  }
}

function getStoreDataKey(){
  return  store_data_key + store_data_version;
}
function getStoreLocationsKey(region) {
  return store_locations_key + '_' + region + store_data_version;
}

const isValidUrl = urlString => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
}

function getReferrerDomain(referrer) {
  if(referrer && isValidUrl(referrer)){
    const domainName = getDomainFromUrl(referrer);
    return domainName;
  } else {
    return null;
  }
}

function getDomainFromUrl(url) {
  const domainName = url.replace(/.+\/\/|www.|\..+/g, '');
  return domainName;
}

//takes a google region id and returns the storelocation object
async function getStoreLocationFromGoogleRegionIDMapping(googleRegionID) {
  var store_locations_url = getStoreLocationsJson();
  const storesData = await fetch(store_locations_url);
  const storesDataJson = await storesData.json();
  const stores = storesDataJson.filter((store) => {
    const storeGoogleRegionIdArray = store.google_region_id.split(',');
    for (const storeGoogleRegionId of storeGoogleRegionIdArray) {
      if (storeGoogleRegionId.toLowerCase() === googleRegionID) {
        return true;
      }
    }
  });
  //if the returned stores has more than one store, the order is the same as in storelocations json file, choose the first store
  if (stores.length === 0) {
    return null;
  } else {
    return stores[0];
  }
}

async function getStoreFromGoogleUrlParameter(url, google_url_parameter) {
  //domainName of referrer exists and is outside domain
  const regionId = GetURLParameter(google_url_parameter, url);
  if (regionId) {
    const regionIdNoQuoteLowercase = regionId.replace(/['"]+/g, '').toLowerCase();
    return getStoreLocationFromGoogleRegionIDMapping(regionIdNoQuoteLowercase);
  } else {
    //domainName of referrer exists and is not outside domain
    return null;
  }
}

async function setGeoDataGoogleRegionIdOverwite(){
  const referrer = document.referrer;
  const domainName = getReferrerDomain(referrer);
  const currentURL = GetCurrentURL(false);
  const currentDomain = getDomainFromUrl(currentURL);
  let store = null;
  if (!domainName) {
    //domainName of referrer does not exist, run the old SetGeoData()
    SetGeoData();
  } else {
    //domainName of referrer exists, try to get the store from google region id
    if (currentDomain && domainName.toLowerCase() != currentDomain.toLowerCase()) {
      store = await getStoreFromGoogleUrlParameter(currentURL, google_url_parameter);
    }
    if(!store){
      SetGeoData();
    } else {
      //store location found from region_id mapping, set the location cookie
      setLocationCookieFromGoogleRegionId(store);
    }
  }
}

function setStoreLocation() {SetGeoData();}

async function SetRegionMappingInLocalStorage(){
  let regionMap = {}
  let defaultExpiryDays = 365;
  if(getLocalStorageWithExpiry(getStoreDataKey()) == null){
    var store_locations_url = getStoreLocationsJson();
    const storesData = await fetch(store_locations_url);
    const storesDataJson = await storesData.json();
    const promises = storesDataJson.map((storeData) => {
      if(!regionMap.hasOwnProperty(storeData.region)){
        let storesArray = [];
        storesArray.push(storeData.id);
        regionMap[storeData.region] = storesArray;
      } else {
        regionMap[storeData.region].push(storeData.id);
      }
    });
    setLocalStorageWithExpiry(getStoreDataKey(), regionMap, defaultExpiryDays);
  }
}

function GetProductHandleFromProductURL(productUrl)
{
  const url = new URL(productUrl);
  const urlArray = url.pathname.split("/");
  return urlArray[urlArray.length -1];
}

function GetHoursDifference(first_date, second_date) {
  const msBetweenDates = Math.abs(second_date.getTime() - first_date.getTime());
  const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);
  return hoursBetweenDates;
}

//Load Clearance Model Available - related, recently etc
function LoadClearanceModelAvailable (param, badgesAjaxResponseArray) {
  $(param).find('.product-item').each(async function() {
    var clearance_model_available_enabled = true;
    var product_id = $(this).attr('product-id');
    const badgesAjaxResponseMatched = badgesAjaxResponseArray.filter((badgesAjaxResponse) => badgesAjaxResponse.product_id == product_id);
    if (clearance_model_available_enabled) {
      if(badgesAjaxResponseArray.length > 0 && badgesAjaxResponseMatched.length == 1){
        var clearance_values = badgesAjaxResponseMatched[0].clearance_values;
        let sale_price = badgesAjaxResponseMatched[0].sale_price;
        if (clearance_values) {
          const currentRegion = await GetSelectedStoreRegion();
          const storesInOneRegionArray = await fetchAllStoresByRegion(currentRegion);
          const region_QOH = await calculateQOHByRegion(currentRegion, clearance_values);
          if(region_QOH > 0){
            if(!$(this).find(".product-item__info").hasClass('clearance-model-available-added')){
                const clearanceText = await getClearanceModelAvailableText(currentRegion, clearance_values, true, sale_price);
                $(this).find(".product-item__info").append(`<div class="clearance-model-available-related-recently" >${clearanceText}</div>`);
                $(this).find(".product-item__info").addClass('clearance-model-available-added');
            }
          }
        }
      } else {
        throw 'badgesAjaxResponseArray null or badgesAjaxResponseMatched length is not correct';
      }
    }
  });
}

async function calculateQOHByRegion(region, clearance_values) {
  let region_QOH = 0;
  const storeArray = await fetchAllStoresByRegion(region);
  clearance_values.forEach((clearance_value) => {
    if(storeArray.includes(parseInt(clearance_value.locationId))){
      region_QOH += clearance_value.QOH;
    }
  });
  return region_QOH;
}

function fetchAllStoresByRegion(region) {
  const regionMapping = getLocalStorageWithExpiry(getStoreDataKey());
  const storesInRegionArray = regionMapping[region];
  return storesInRegionArray;
}


async function getStoresFromRegion(region){
  return new Promise(function(resolve, reject){
    const storeLocationsKey = getStoreLocationsKey(region);
    const storeLocations = sessionStorage.getItem(storeLocationsKey);
    if(storeLocations == null) {
      const store_locations_url = getStoreLocationsJson();
      $.getJSON(store_locations_url, function(storedata) {
        let regionStores = storedata.filter((store) => {
          return store.region === region;
        });
        sessionStorage.setItem(storeLocationsKey, JSON.stringify(regionStores));
        resolve(regionStores);
      });
    } else {
      resolve(JSON.parse(storeLocations));
    }
  });
}

async function getMinRegionalClearancePrice(region, clearance_values) {
  let minRegionalClearancePrice = null;
  if (!clearance_values) {
    return minRegionalClearancePrice;
  }
  const storeArray = await fetchAllStoresByRegion(region);
  for (let clearance_value of clearance_values) {
    if (storeArray.indexOf(parseInt(clearance_value.locationId)) !== -1) {
      if (clearance_value.minRegionalClearancePrice) {
        minRegionalClearancePrice = clearance_value.minRegionalClearancePrice;
      }
      break;
    }
  }
  return minRegionalClearancePrice;
}

function productHasReview(productInfoElement) {
 if(productInfoElement.find('.isp_product_review').length > 0){
   return true;
 } else {
   return false;
 }
}

function getCanadaCurrency(num, useGrouping) {
  const canadaCurrency = new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    useGrouping: useGrouping,
  });
  return canadaCurrency.format(num);
}

async function getClearanceModelAvailableText(currentRegion, clearance_values, useGroupingForCurrency, sale_price) {
  const minRegionalClearancePrice = await getMinRegionalClearancePrice(currentRegion, clearance_values);
  const defaultClearanceModelText = "Clearance Model Available"
  let clearanceModelText = defaultClearanceModelText;
  if(sale_price){
    sale_price = parseFloat(sale_price.replace(/,/g, ''));
  }
  if ((minRegionalClearancePrice && sale_price && (minRegionalClearancePrice < sale_price)) || (minRegionalClearancePrice && !sale_price)) {
    const clearanceModelTextWithValue  = "Clearance Model \u003cb\u003eStarting From {minRegionalClearancePrice}\u003c\/b\u003e";
    minRegionalClearancePriceFormatted = getCanadaCurrency(minRegionalClearancePrice, useGroupingForCurrency);
    clearanceModelText = clearanceModelTextWithValue.replace('{minRegionalClearancePrice}', minRegionalClearancePriceFormatted);
  }
  return clearanceModelText;
}

//Load Clearance Model Available - plp  called in coast-product.js.liquid
async function LoadClearanceModelAvailablePLP(clearance_values, productInfoElement, sale_price) {
  const currentRegion = await GetSelectedStoreRegion();
  var region_QOH = 0;
  if(clearance_values){
    const region_QOH = await calculateQOHByRegion(currentRegion, clearance_values);
    if(region_QOH > 0){
      if (!productInfoElement.hasClass('available-on-clearance-added')) {
        const clearanceModelText = await getClearanceModelAvailableText(currentRegion, clearance_values, false, sale_price);
        const hasReview = productHasReview(productInfoElement);
        let marginStyle = productHasReview ? '' : 'style="margin-top:2.4rem;"';
        productInfoElement.after(`<div class="plp-clearance-model-available" ${marginStyle}>${clearanceModelText}</div>`);
        productInfoElement.addClass('available-on-clearance-added');
      }
    }
  }
}

function GetBadgesAjaxResponseArray(param) {
  var storeId = GetSelectedStoreId();
  const promises = $(param).find('.product-item').map(function() {
    const baseUrl = $(this).find('a').attr('href').split('?')[0];
    let url =  baseUrl + '?view=badgesajax&store_id='+ storeId + '&type=' + GetRandomInt(1,100) + '&cache=false&quantity='+ GetRandomInt(1,100);
    return new Promise(async (resolve, reject) => {
      let BadgesAjaxResponse = await fetch(url);
      let BadgesAjaxResponseJson = await BadgesAjaxResponse.json();
      resolve(BadgesAjaxResponseJson);
    });
  });
  return  Promise.all(promises);
}



//Load Sale Ends Date - related, recently etc
function LoadSaleEndsDate (param, badgesAjaxResponseArray) {
  var sale_ends_date_enabled = false;
  $(param).find('.product-item').each(function() {
    var product_id = $(this).attr('product-id');
    const badgesAjaxResponseMatched = badgesAjaxResponseArray.filter((badgesAjaxResponse) => badgesAjaxResponse.product_id == product_id);
    if (sale_ends_date_enabled) {
      if(badgesAjaxResponseArray.length > 0 && badgesAjaxResponseMatched.length == 1){
        var sale_end_date_display = badgesAjaxResponseMatched[0].sale_end_date_display;
        var sale_end_date = badgesAjaxResponseMatched[0].sale_end_date;
        if (sale_end_date) {
          const sale_ends_date_formatted = new Date(sale_end_date);
          const current_date_formatted = new Date();
          if (current_date_formatted < sale_ends_date_formatted) {
            const hoursBetweenDates = GetHoursDifference(current_date_formatted, sale_ends_date_formatted);
            if(!$(this).find(".product-item__price-list").hasClass('sale-ends-date-added')){
              if ( hoursBetweenDates > 24 && hoursBetweenDates < 48 ) {
                $(this).find(".product-item__price-list").after(`<div class="pdp-sale-ends-date-related-recently" >Saving Ends: Tomorrow </div>`);
                $(this).find(".product-item__price-list").addClass('sale-ends-date-added');
              }
            }
            if(!$(this).find(".product-item__price-list").hasClass('sale-ends-date-added')){
              if ( hoursBetweenDates > 0 && hoursBetweenDates <= 24 ) {
                $(this).find(".product-item__price-list").after(`<div class="pdp-sale-ends-date-related-recently" >Saving Ends: Today </div>`);
                $(this).find(".product-item__price-list").addClass('sale-ends-date-added');
              }
            }
            if(!$(this).find(".product-item__price-list").hasClass('sale-ends-date-added')){
              $(this).find(".product-item__price-list").after(`<div class="pdp-sale-ends-date-related-recently" >Saving Ends: ${sale_end_date_display}</div>`);
            }
          }
        } else {
          $(this).find(".product-item__price-list").after(`<div class="pdp-sale-ends-date-related-recently" style="visibility: hidden;">  &nbsp </div>`);
        }
      } else {
        throw 'badgesAjaxResponseArray null or badgesAjaxResponseMatched length is not correct';
      }
    }
  });
}

/** Badges on items - related, recently etc **/

function LoadProductBadges (param) {
  const productItemElements = param.querySelectorAll('.product-item');
  for (const productItemElement of productItemElements) {
    const previousElement = productItemElement.querySelector('.badge--instock-container');
    const inStockLabelElement = previousElement.querySelector('.badge--instock-label');
    const maxPromoBadges = inStockLabelElement ? 1 : 2; /* if the in stock element is not visible we render max 2 promo badges */
    let promoBadgesCount = 0;
    let hasPromoBadge = false;
    const badgeContainerTemplate = document.createElement('div');
    badgeContainerTemplate.classList.add('product-item-badge', 'badge-block');
    const globalProductBadgeTags = typeof productBadgeTags !== 'undefined' ? productBadgeTags : [];

    for (const badgeData of globalProductBadgeTags) { /* now we iterate through the global varibales for productBadgeTags and apply them to the productItemElement */
      const tagname = badgeData.tag.replaceAll(' ', '::');
      /* if the tag is not applicable to the productItem, or we have rendered the max promo badges continue*/
      if(!productItemElement.classList.contains(tagname) || promoBadgesCount >= maxPromoBadges) {
        continue;
      }
      const badgeContainer = badgeContainerTemplate.cloneNode(true);
      if (badgeData.style === 'pdp_badge_style_tgr' || badgeData.style === 'pdp_badge_style_tgl') {
        badgeContainer.classList.add('badge-hide-overflow', 'badge-nowrap');
        const parent = productItemElement.querySelector('.product-item-badges-container');
        if (parent) {
          parent.classList.add('badge-hide-overflow');
        }
      }

      const badgeElement = document.createElement('span');
      badgeElement.classList.add(badgeData.style);
      badgeElement.textContent = badgeData.badge_content;
      badgeElement.style.background = badgeData.background_color;
      badgeElement.style.color = badgeData.text_color;

      if (badgeData.is_link_enabled && badgeData.url.length > 0) {
        const linkElement = document.createElement('a');
        linkElement.href = badgeData.url;
        if (badgeData.link_onclick.trim().length > 0) {
          const onClickValue = badgeData.link_onclick.trim() + ' return false;';
          linkElement.setAttribute('onclick', onClickValue);
        }
        if (badgeData.style === 'pdp_badge_style_prg') {
          linkElement.classList.add('badge-inline');
        } else if (badgeData.style === 'pdp_badge_style_tgr' || badgeData.style === 'pdp_badge_style_tgl') {
          linkElement.classList.add('badge-hide-overflow');
        }
        linkElement.append(badgeElement);
        badgeContainer.append(linkElement);
      } else {
        badgeContainer.append(badgeElement);
      }

      /* now we add the badge and update the variables */
      previousElement.after(badgeContainer);
      hasPromoBadge = true;
      promoBadgesCount++;

      /* now we add the style elements if applicable */
      const itemClass = productItemElement.id;
      const itemStyleElement = document.createElement('style');
      if (badgeData.style == 'pdp_badge_style_tgr') {
        itemStyleElement.innerHTML = `
        .${itemClass} .pdp_badge_style_tgr::after { border-left: 13px solid ${badgeData.background_color}; }
        .${itemClass} .pdp_badge_style_tgr::before{ background: ${badgeData.text_color}; }`;
      } else if (badgeData.style == 'pdp_badge_style_tgl') {
        itemStyleElement.innerHTML = `
        .${itemClass} .pdp_badge_style_tgl::before { border-right: 13px solid ${badgeData.background_color}; }
        .${itemClass} .pdp_badge_style_tgl::after { background: ${badgeData.text_color}; }`;
      }
      if (itemStyleElement.innerHTML.length > 0) {
        previousElement.after(itemStyleElement);
      }
    }

    if (hasPromoBadge === false) {
      const badgeContainer = badgeContainerTemplate.cloneNode(true);
      const badgePlaceholderElement = document.createElement('span');
      badgePlaceholderElement.classList.add('item-no-badge-placeholder');
      badgeContainer.append(badgePlaceholderElement);
      previousElement.after(badgeContainer);
    }
  }
  return this;
};


function GetRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function GetURLParameter(parameterName, url) {
  let result = null;
  if (url === undefined) {
    url = GetCurrentURL(false);
  }
  if (url && isValidUrl(url)) {
    let urlObj = new URL(url);
    var urlParams = new URLSearchParams(urlObj.search);
    if (urlParams.has(parameterName)) {
      let value = urlParams.get(parameterName);
      result = value;
    }
  }
  return result;
}

// faqContent should be string type
function GetFaqSchema(faqContent, questionClassName, answerClassName){
  const content = new DOMParser().parseFromString(faqContent, "text/html");
  const questions = content.getElementsByClassName(questionClassName);
  const answers = content.getElementsByClassName(answerClassName);
  let entityArray  = [ ];
  const faqSchemaFormat =
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
          ]
        };
  if (questions.length > 0){
    for (let i = 0; i < questions.length; i++){
      entityArray[i] = {
        "@type": "Question",
        "name": `${questions[i].innerHTML}`,
        "acceptedAnswer": {
        "@type": "Answer",
        "text": `${answers[i].querySelector("p").innerHTML}`
        }
      };
    }
  }
  faqSchemaFormat["mainEntity"].push(entityArray);
  const faqSchemaString = JSON.stringify( faqSchemaFormat);
  let faqScript = document.createElement('script');
  faqScript.type = 'application/ld+json';
  faqScript.innerText = faqSchemaString;

  return faqScript;
}

function GetQuickshipMetafields(storeId, quickshipMetafields) {
  let QOH, SQOH, pickup_QOH, pickup_SQOH, total_QOH, shippingTier, isDiscontinued, isSpecialOrder;
  let metafields = {
    QOH : QOH,
    SQOH: SQOH,
    pickup_QOH: pickup_QOH,
    pickup_SQOH: pickup_SQOH,
    total_QOH: total_QOH,
    shipping_tier: shippingTier,
    special_order: isSpecialOrder,
    discontinued: isDiscontinued,
  };
  if(quickshipMetafields.length > 0) {
    const retrievedMetafields = quickshipMetafields.find((location) => location.locationId == storeId);
    metafields = Object.assign({}, metafields, retrievedMetafields);
  }
  return metafields;
}

async function getProductDataByHandle (productHandle, options) {
  let url = `/products/${productHandle}?view=data`;
  if(options) {
    for(const [key, value] of Object.entries(options))
    url += `&${key}=${value}`;
  }
  let productData = '';
  try {
    await fetch(url).then(e => {
      productData = e.text();
    });
  } catch (e) {
    console.log('Error getProductDataByHandle', e);
  }
  return productData;
}

function updateComparableTable (productSummaries, productsLoaded) {
  const storeId = GetSelectedStoreId();
  for (const productSummary of productSummaries) {
    const productHandle = productSummary.dataset.handle;
    const isLoaded = productsLoaded.includes(productHandle);
    if(isLoaded) {
      continue;
    }
    const removeElem = productSummary.parentElement.querySelector('.remove-from-compare');
    const priceElem = productSummary.querySelector('.product-price');
    const buttonCTA = productSummary.querySelector('.add-to-cart-wrap');
    productsLoaded.push(productHandle);
    if(priceElem && buttonCTA && productHandle && !isLoaded) {
      let shortText = false;
      if(window.innerWidth <= 767) {/* 767 is the max width for mobile in Comparable */
        shortText = true;
      }
      const options = {
        store_id: storeId,
        short_text: shortText
      }
      getProductDataByHandle(productHandle, options).then(e => {
        const product = JSON.parse(e);
        const metafields = product.store_metafields;
        const isViewButton = !!buttonCTA.querySelector('.add-to-cart')?.hasAttribute('href');
        const isBuyButtonAlt = (metafields.total_QOH < 1 && metafields.shipping_tier == 7) || product.template === 'luxury';
        if(!isViewButton && isBuyButtonAlt && product.buy_button) {
          const decodeElem = document.createElement("textarea");
          decodeElem.innerHTML = product.buy_button;
          let buttonCTAInner = decodeElem.value;
          buttonCTA.innerHTML = buttonCTAInner;
        } else {
          const addToCartButton = buttonCTA.querySelector('.add-to-cart');
          if (!addToCartButton?.classList.contains('listener-added')) {
            addToCartButton?.classList.add('listener-added');
            addToCartButton?.addEventListener("click", () => {
              addToCartButton?.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                    quantity: 1
                }
              }));
            });
          }
        }
        const isHidePrice = product.tags.includes('ISP_NO_PRICE');
        if(!isHidePrice) { /* if we need to hide the price, this in style change overrides the class where we hide the price in the pop up*/
          priceElem.style.display = 'flex';
        }
     }).catch((err) => {
        console.log('Error getting product data to show price in Comparable table', productHandle, err);
      })
    }
  }
}
